import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "bg-white rounded-xl shadow-xl max-w-2xl w-full overflow-hidden",
  role: "dialog",
  "aria-labelledby": "trend-modal-title"
}
const _hoisted_2 = { class: "px-6 py-4 border-b border-gray-200 flex items-center justify-between" }
const _hoisted_3 = {
  id: "trend-modal-title",
  class: "text-lg font-semibold text-gray-900"
}
const _hoisted_4 = { class: "px-6 py-6" }
const _hoisted_5 = {
  key: 0,
  class: "text-center py-12 text-gray-500"
}
const _hoisted_6 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_7 = { class: "flex-1 min-w-0 pb-2" }
const _hoisted_8 = ["viewBox"]
const _hoisted_9 = ["y1", "y2", "x1", "x2"]
const _hoisted_10 = ["x", "y"]
const _hoisted_11 = ["points"]
const _hoisted_12 = ["cx", "cy"]
const _hoisted_13 = ["x", "y"]
const _hoisted_14 = { class: "mt-4 border border-gray-200 rounded-lg overflow-hidden" }
const _hoisted_15 = { class: "w-full text-sm" }
const _hoisted_16 = { class: "divide-y divide-gray-100" }
const _hoisted_17 = { class: "px-4 py-2 text-gray-700" }
const _hoisted_18 = { class: "px-4 py-2 text-right font-medium text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.topic)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.topic.topic) + " — Daily mentions ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-400 hover:text-gray-600 p-1 rounded transition-colors",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.sortedData.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No trend data available "))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock("svg", {
                      viewBox: `0 0 ${_ctx.chartWidth} ${_ctx.chartHeight + 48}`,
                      class: "w-full text-violet-500 block",
                      style: {"height":"12rem"},
                      preserveAspectRatio: "xMidYMid meet"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yTicks, (tick) => {
                        return (_openBlock(), _createElementBlock("g", {
                          key: tick.value,
                          class: "text-gray-200"
                        }, [
                          _createElementVNode("line", {
                            y1: tick.y,
                            y2: tick.y,
                            x1: _ctx.plotLeft,
                            x2: _ctx.plotRight,
                            stroke: "currentColor",
                            "stroke-width": "0.5",
                            "stroke-dasharray": "4 2"
                          }, null, 8, _hoisted_9)
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yTicks, (tick) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: 'lbl-' + tick.value,
                          x: _ctx.plotLeft - 8,
                          y: tick.y,
                          "text-anchor": "end",
                          "dominant-baseline": "middle",
                          class: "text-gray-500 fill-current",
                          style: {"font-size":"11px","font-family":"ui-monospace, monospace"}
                        }, _toDisplayString(tick.value), 9, _hoisted_10))
                      }), 128)),
                      _createElementVNode("polyline", {
                        points: _ctx.pathPoints,
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, 8, _hoisted_11),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartPoints, (pt, i) => {
                        return (_openBlock(), _createElementBlock("g", { key: i }, [
                          _createElementVNode("circle", {
                            cx: pt.x,
                            cy: pt.y,
                            r: "4",
                            fill: "currentColor"
                          }, null, 8, _hoisted_12)
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelPoints, (lp, i) => {
                        return (_openBlock(), _createElementBlock("text", {
                          key: i,
                          x: lp.x,
                          y: _ctx.chartHeight + 24,
                          "text-anchor": "middle",
                          "dominant-baseline": "hanging",
                          class: "text-gray-500 fill-current",
                          style: {"font-size":"11px"}
                        }, _toDisplayString(_ctx.formatDate(lp.processed_date)), 9, _hoisted_13))
                      }), 128))
                    ], 8, _hoisted_8))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("table", _hoisted_15, [
                      _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "px-4 py-2 text-left font-medium text-gray-700" }, " Date "),
                          _createElementVNode("th", { class: "px-4 py-2 text-right font-medium text-gray-700" }, " Mentions ")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (d) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: d.processed_date,
                            class: "hover:bg-gray-50"
                          }, [
                            _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatDate(d.processed_date)), 1),
                            _createElementVNode("td", _hoisted_18, _toDisplayString(d.count), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}